import { Step } from '@/components/stepper/stepper.types';

export const RegisterSteps: Step[] = [
	{
		id: 1,
		icon: 'icons-user-id',
		title: 'Kişisel Bilgiler',
		description: 'Lütfen kişisel bilgilerinizi eksiksiz ve doğru şekilde doldurun.'
	},
	{
		id: 2,
		icon: 'icons-cap',
		title: 'Eğitim Bilgileri',
		description: 'Lütfen eğitim bilgilerinizi eksiksiz ve doğru şekilde doldurun.'
	},
	{
		id: 3,
		icon: 'icons-school-minimalistic',
		title: 'Çalışma Bilgileri',
		description: 'Lütfen çalışma bilgilerinizi eksiksiz ve doğru şekilde doldurun.'
	}
];
